import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'VbUpdateTranslationParams',
    standalone: false
})
export class VbUpdateTranslationParamsPipe implements PipeTransform {
	transform(value: string, replacements: { [key: string]: string }): string {
		for (const key in replacements) {
			value = value.replace(`{${key}}`, replacements[key]);
		}
		return value;
	}
}
